import React, { useState, useEffect } from 'react'
import './MyEventHome.css'
import HomeCard from './HomeCard.js';
import {apiGetCurrentUser, apiGetEventById} from '../api/api.js'


const MyEventHome = () => {
    const [userEvent, setUserEvent] = useState([]);
    const [userEventID, setUserEventID] = useState([]);
    const [userEventImage, setUserEventImage] = useState([]);
    const getCurrentUser = () => {
      apiGetCurrentUser()
      .then((response)=> {
        const userInfo = response.data.user.eventEnrolled;
        for(let i = 0; i< userInfo.length; i++){
          apiGetEventById(userInfo[i])
          .then((res)=> {
            const eventName = res.data.content.name;
            const eventImage = res.data.content.image ? res.data.content.image:"default";
            console.log(eventImage)
            setUserEventID(userEventID => [...userEventID, userInfo[i]])
            setUserEvent(userEvent => [...userEvent, eventName])
            setUserEventImage(userEventImage => [...userEventImage, eventImage])
          })
          
        }
      })
    }
    useEffect(() => {
      getCurrentUser();
    }, []);
    var cardTotal = (userEvent == null) ? 0 : userEvent.length;
    if(cardTotal > 3){
        cardTotal = 4;
    }
    const rowList=[];
    for(let i=0; i<cardTotal; i++){
      userEventImage[i] === "default"?
      rowList.push(<HomeCard groupName={userEvent[i]} url={userEventID[i]} type="event"/>)
      :
      rowList.push(<HomeCard groupName={userEvent[i]} url={userEventID[i]} type="event" imageUrl={userEventImage[i]}/>)
    }
    return (
      <div className="MyEventHome">
        <p className='MyEventTitle'>My Event</p>
        <p className="viewAll">
            <a href="/my-events">View All{'>'}</a>
        </p>
        <div className='flexContainer'>
            {rowList}
        </div>
      </div>
    );
  }
  
  export default MyEventHome